export const RECORDS_BY_PAGE = 50
export const SORT_ASC = 'asc'
export const SORT_DESC = 'des'
